import React from "react";
import "./style/PbgPageTwo.scss";

const PbPageTwo = () => {
  return <div className="PbgPageTwo_container"></div>;
};

export default PbPageTwo;
